import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";

/**
 * Mimics the same layout as the home component, but
 * with skeleton loaders in place of actual data.
 */
function MyChapterDashboardLoadingSkeleton() {
  return (
    <MainPageWrapper>
      <div className="flex min-h-screen flex-col p-4">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-8 w-32" />
        </div>

        {/* Section 1: Stats Cards */}
        <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {/* Advisors Skeleton Card */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow">
            <Skeleton className="h-5 w-1/2 mb-2" />
            <Skeleton className="h-7 w-1/3" />
          </div>

          {/* Officers Skeleton Card */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow">
            <Skeleton className="h-5 w-1/2 mb-2" />
            <Skeleton className="h-7 w-1/3" />
          </div>

          {/* Members Skeleton Card */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow">
            <Skeleton className="h-5 w-1/2 mb-2" />
            <Skeleton className="h-7 w-1/3" />
          </div>
        </div>

        {/* Section 2: Charts */}
        <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Leadership Pie Chart */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow h-[360px]">
            <Skeleton className="h-5 w-1/2 mb-3" />
            <Skeleton className="h-[260px] w-full" />
          </div>

          {/* Bar Chart */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow h-[360px]">
            <Skeleton className="h-5 w-1/2 mb-3" />
            <Skeleton className="h-[260px] w-full" />
          </div>
        </div>

        {/* Section 3: Chapter Info */}
        <div className="mb-6 rounded-xl border bg-gray-50 p-4 shadow space-y-2">
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="h-5 w-1/4" />
          <Skeleton className="h-5 w-1/5" />
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-5 w-1/2" />
        </div>

        {/* Section 4: Advisors and Officers */}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          {/* Advisors Skeleton */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow space-y-2">
            <Skeleton className="h-5 w-1/2" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-5 w-1/2" />
          </div>

          {/* Officers Skeleton */}
          <div className="rounded-xl border bg-gray-50 p-4 shadow space-y-2">
            <Skeleton className="h-5 w-1/2" />
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-5 w-1/2" />
          </div>
        </div>
      </div>
    </MainPageWrapper>
  );
}

export default MyChapterDashboardLoadingSkeleton;
